import { WorkspaceFilters, type WorkspaceFiltersProps } from './WorkspaceFilters';

/**
 * The toolbar shell. Filters sit ABOVE the stage tabs rather than inside them,
 * which is the visual statement of the same rule the URL encodes: stage is one
 * more filter dimension, and switching stage keeps everything else (FR-2.3).
 */
export function WorkspaceToolbar(props: WorkspaceFiltersProps) {
  return (
    <div className="rounded-lg border bg-white p-3">
      <WorkspaceFilters {...props} />
    </div>
  );
}
